import { useEffect, useMemo, useState } from 'react';
import { GetCustomizeCar_customizeCar_availableFeatureCategories as FeatureCategory } from '../../graphql/queries/__generated__/GetCustomizeCar';
import availableFeatureCategoriesServices from '../../service/availableFeatureCategoriesService';
import { useHistory } from 'react-router';
import checkIfStockPage from '../../../gqlCommon/service/checkIfStockPage';
import useCustomizeCarContext from '../useCustomizeCarContext';

export const useAvailableFeatureCategories = (): {
  featureSections: FeatureCategory[];
  featureCategories: FeatureCategory[];
} => {
  const { selectedCar, loading } = useCustomizeCarContext();
  const history = useHistory();
  const features = useMemo(() => selectedCar?.availableFeatures, [selectedCar]);

  const [featureSections, setFeatureSections] = useState<FeatureCategory[]>([]);
  const [featureCategories, setFeatureCategories] = useState<FeatureCategory[]>([]);

  useEffect(() => {
    if (!loading && selectedCar) {
      const isStockPage = checkIfStockPage.isInStockDetailsPage(history);
      const stockFeatureCategories = availableFeatureCategoriesServices.getAccessoriesFeatureCategory(
        selectedCar?.availableFeatureCategories,
      );

      const featureAvailableCategories = isStockPage ? stockFeatureCategories : selectedCar?.availableFeatureCategories;

      const availableSectionsNames = availableFeatureCategoriesServices.getAvailableSectionsNames(
        featureAvailableCategories,
        features,
      );

      setFeatureSections(availableSectionsNames);
      setFeatureCategories(featureAvailableCategories);
    }
  }, [selectedCar]);

  return { featureSections, featureCategories };
};
